import {
  ConnectionError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../../modules/app/errors';

const POST_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const lostCardUrl = (printedCardNumber) => (
  `${api_config.bet_tracker_api}/card/${printedCardNumber}/reportLost`
);

// eslint-disable-next-line import/prefer-default-export
export const postLostCard = (printedCardNumber) => (
  fetch(lostCardUrl(printedCardNumber), {
    method: 'POST',
    headers: POST_HEADERS,
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return response;
        }
        case 400:
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);
